import { filter, Subject, take } from 'rxjs';
import { EntityEventMessengerEnum } from '../../../../../types/src/common/enum/entity-event-messenger.enum';

export const eventReceived = new Subject<string>();

export function onEvent(event: EntityEventMessengerEnum, callback: CallableFunction) {
    eventReceived
        .pipe(filter((it) => it === event))
        .pipe(take(1))
        .subscribe(() => {
            callback();
        });
}

export function onEventMarker(event: EntityEventMessengerEnum, timeout: number = 1_000): Promise<boolean> {
    let resolve: any;
    const promise = new Promise<boolean>((res) => {
        resolve = res;
    });

    const maxTimeout = new Promise<boolean>(res => setTimeout(() => res(false), timeout));

    eventReceived
        .pipe(filter((it) => it === event))
        .pipe(take(1))
        .subscribe(() => resolve(true));

    return Promise.race([promise, maxTimeout]);
}
